import Device from './Device';

/** Class representing a host (pi). */
class Host extends Device {
    /* Host available actions */
    static ACTION_REBOOT                = 'reboot';
    static ACTION_SHUTDOWN              = 'shutdown';
    static ACTION_RESTART_PIHYVE        = 'restart_pihyve';
    static ACTION_PROCESSES             = 'processes';
    static ACTION_DISK_USAGE            = 'disk_usage';
    static ACTION_SHOW_PRINT_QUEUE      = 'show_print_queue';
    static ACTION_CANCEL_PRINT_QUEUE    = 'cancel_print_queue';
    static ACTION_PIHYVE_LOGS           = 'pihyve_logs';
    static ACTION_PIHYVE_CONFIG         = 'pihyve_config';
    static ACTION_PIHYVE_RECONFIGURE    = 'pihyve_reconfigure';
    static ACTION_CHECK_UPGRADE         = 'check_upgrade';
    static ACTION_GIT_PULL              = 'git_pull';
    static ACTION_GIT_STATUS            = 'git_status';
    static ACTION_GIT_DIFF              = 'git_diff';
    static ACTION_INSTALL_DEPS          = 'install_deps';
    static ACTION_LS_USB                = 'ls_usb';
    static ACTION_SHOW_IPS              = 'show_ips';
    static ACTION_LIST_WIFI_SSIDS       = 'list_wifi_ssids';
    static ACTION_LIST_NETWORKS         = 'list_networks';
    static ACTION_SHOW_CUSTOM_NETWORK   = 'show_custom_network';
    static ACTION_SET_CUSTOM_NETWORK    = 'set_custom_network';
    static ACTION_TEST_CUSTOM_NETWORK   = 'test_custom_network';
    static ACTION_DELETE_CUSTOM_NETWORK = 'delete_custom_network';

    constructor(properties) {
        super({
            ...properties,
            type: 'host'
        });

        this.connectedDevices = [];
    }

    isManaged () {
        return ('options' in this);
    }

    isPi () {
        return this.options?.model?.match(/raspberry/i);
    }

    isMiniPc () {
        return this.options?.model?.match(/medion/i);
    }

    is4Pos () {
        return this.options?.model?.match(/4pos/i);
    }

    connectDevice(device) {
        this.connectedDevices = [
            ...(this.connectedDevices.filter(d => d._id !== device._id)),
            device
        ];
    }

    disconnectDevice(device) {
        this.connectedDevices = this.connectedDevices.filter(d => d._id !== device._id);
    }

    getConnectedDevices() {
        return this.connectedDevices;
    }

    piNumber() {
        if (!this.options?.hostname?.length)
            return null;

        const { hostname } = this.options;
        if (!hostname.match(/-pi\d+|-pi-.+|caisse-|tkt-.+/))
            return null;

        const parts = hostname.split('-');
        return parts[parts.length - 1];
    }
}

export default Host;
